// 脚本类型映射配置
export const scriptTypeMap: Record<number, string> = {
  1: "Horror",
  2: "Deduction",
  3: "Fun",
  4: "Rule-based",
  5: "Immersive",
  6: "Comedy",
  7: "Drama",
  8: "Fantasy",
  9: "Thriller",
  10: "Mystery",
  // 可以根据需要添加更多映射
};

// 获取脚本类型名称
export function getScriptTypeName(typeId: number): string {
  return scriptTypeMap[typeId] || 'Script';
}

// 其他脚本相关的全局配置可以添加在这里
export const scriptConfig = {
  // 最大玩家数
  maxPlayers: 10,
  
  // 默认游戏时长 (分钟)
  defaultGameDuration: 120,
  
  // 脚本难度级别
  difficultyLevels: {
    1: "Easy",
    2: "Medium",
    3: "Hard",
    4: "Expert"
  }
}; 
